import { render, staticRenderFns } from "./InsPhotoGallery.vue?vue&type=template&id=b26aec2c&scoped=true&"
import script from "./InsPhotoGallery.vue?vue&type=script&lang=ts&"
export * from "./InsPhotoGallery.vue?vue&type=script&lang=ts&"
import style0 from "./InsPhotoGallery.vue?vue&type=style&index=0&id=b26aec2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26aec2c",
  null
  
)

export default component.exports